import React from 'react';
import { Box, Button, Flex, Link, Spacer, Image } from "@chakra-ui/react";
import Facebook from "./assets/assets/social-media-icons/facebook_32x32.png";
import Twitter from "./assets/assets/social-media-icons/twitter_32x32.png";
import Email from "./assets/assets/social-media-icons/email_32x32.png";
const NavBar = ({ accounts, setAccounts }) => {
    const isConnected = Boolean(accounts[0]);

    async function connectAccount() {
        if (window.ethereum) { //we check whether our browser have ethereum environment like Metamask
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            setAccounts(accounts);
        }
    }
    return (
        <div>
            <Flex justify="space-around" align="center" padding="30px" width={["none", "none", "100%"]}>
                {/* Left side- social media Icons */}
                <Flex justify="space-around" width="40%" padding="0 75px">
                    <Link href='https://www.facebook.com/pratyush.rinku/'>
                        <Image src={Facebook} boxSize="42px" margin="0 15px" />
                    </Link>
                    <Link href='https://twitter.com/Pratyus10032001'>
                        <Image src={Twitter} boxSize="42px" margin="0 15px" />
                    </Link>
                    <Link href='https://gmail.com'>
                        <Image src={Email} boxSize="42px" margin="0 15px" />
                    </Link>
                </Flex>
                {/* Right side- social media Icons */}
                <Flex justify="space-around" align="center" width="40%" padding="30px">
                    <Box margin="0 15px">About</Box>
                    <Spacer />
                    <Box margin="0 15px">Mint</Box>
                    <Spacer />
                    <Box margin="0 15px">Team</Box>
                    <Spacer />
                    {/* Connect */}
                    {isConnected ? (
                        <Box margin="0 15px">Connected</Box>
                    ) : (
                        <Button
                            backgroundColor="#5e0034"
                            borderRadius="5px"
                            boxShadow="opx 2px 2px 1px #0F0F0F"
                            color="white"
                            cursor="pointer"
                            fontFamily="inherit"
                            padding="15px"
                            margin="0 15px"
                            onClick={connectAccount}>Connect</Button>
                    )}
                </Flex>
            </Flex>
        </div>
    );
};
export default NavBar;